import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { rem, SettingsItem } from 'design-system';
import { IconFatPlus } from 'design-system/icons';
import useRequiredBenefitCallback from 'features/premium/hooks/useRequiredBenefitCallback';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { isWeb } from '../../../constants';
import { showDeletedPotAlert } from '../utils';
const AddGoalSectionButton = ({ pot }) => {
    const { navigateDeprecated } = useMainStackNavigation();
    const handlePress = useRequiredBenefitCallback(useCallback(() => {
        if (pot.deletedAt) {
            showDeletedPotAlert();
            return;
        }
        navigateDeprecated('EditPotGoal', { pot });
    }, [pot]), 'savingGoals');
    return (<TouchableBounceCard noMarginBottom noMarginTop onDark onPress={handlePress} style={styles.card}>
      <SettingsItem disabled title="Set a goal" icon={<IconFatPlus colorKey="brand"/>}/>
    </TouchableBounceCard>);
};
const styles = StyleSheet.create({
    card: {
        ...(isWeb && {
            padding: rem(8),
        }),
    },
});
export default AddGoalSectionButton;
